import Tabs from "../../components/common/Tabs";
import { AdminStoreTabs } from "../../utils/constants";
import AdminSidebarToggle from "../../components/Admin/AdminSidebarToggle";

const StoreAdminDashboard = () => {
  return (
    <section>
      <div className="flex items-center mb-4">
        <Tabs tabs={AdminStoreTabs} prefix={<AdminSidebarToggle />} />
      </div>
    </section>
  );
};

export default StoreAdminDashboard;
